import { render, staticRenderFns } from "./Tagger.vue?vue&type=template&id=214f08cd&scoped=true"
import script from "./Tagger.vue?vue&type=script&lang=ts"
export * from "./Tagger.vue?vue&type=script&lang=ts"
import style0 from "./Tagger.vue?vue&type=style&index=0&id=214f08cd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "214f08cd",
  null
  
)

export default component.exports